<div class="loading-wrapper">
    <span class="loader"></span>
</div>